import { PositionType, SizeType } from '../../../lib/defs/types';
import {
  despawnOverlayEntity,
  spawnOverlayEntity,
} from '../../entities/OverlayEntity';
import { GameScene } from '../../GameScene';
import { IEffect } from './IEffect';
import { waitAFrame } from '../../../lib/util/waitAFrame';
import { CrateBlockView } from '../../blocks/crate/CrateBlockView';
import { waitFor } from '../../../lib/util/waitFor';
import { CrateBreakAnimation } from '../../animations/CrateBreakAnimation';

export type CrateBreakEffectOptions = {
  position: PositionType;
  size: SizeType;
  view: CrateBlockView;
};

/*
  Crate break effect
*/
export class CrateBreakEffect implements IEffect {
  private readonly scene: GameScene;
  private readonly view: CrateBlockView;
  private readonly position: PositionType;
  private readonly size: SizeType;

  constructor(scene: GameScene, options: CrateBreakEffectOptions) {
    this.scene = scene;
    this.view = options.view;
    this.position = options.position;
    this.size = options.size;
  }

  public async execute() {
    // Play the animation.
    this._animate();

    // Wait only a frame, do not wait for the whole animation.
    await waitAFrame();
  }
  private async _animate() {
    // create debris VFX animation
    const animation = this.view.addChild(new CrateBreakAnimation());

    // Spawn the movie clip as an overlay entity.
    const entity = spawnOverlayEntity(
      this.scene,
      this.position,
      this.size,
      () => this.view,
    );

    // Play the animations
    await Promise.all([
      waitFor(150).then(() => animation.start()),
      this.view.playBreakAnimation(),
    ]);

    this.view.removeChild(animation);

    // Despawn overlay entity.
    despawnOverlayEntity(this.scene, entity);
  }
}
